<template>
  <div
    @mouseenter="onMouseEnter"
    @mouseleave="onMouseLeave"
    @mousemove="onMouseMove"
    style="display: inline-block; width: 100%; height: 100%"
  >
    <slot></slot>
    <transition name="fade">
      <div
        v-if="isVisible"
        :style="{
          position: 'fixed',
          top: cursorY - offsetY + 'px',
          left: cursorX + offsetX + 'px',
          ...tooltipStyle,
          pointerEvents: 'none',
          zIndex: 1000,
        }"
      >
        <slot name="tooltip">Tooltip</slot>
      </div>
    </transition>
  </div>
</template>

<script>
export default {
  name: "ChartTooltip",
  props: {
    timeout: {
      type: Number,
      default: 3000,
    },
    offsetX: {
      type: Number,
      default: 10,
    },
    offsetY: {
      type: Number,
      default: 40,
    },
    tooltipStyle: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      isVisible: false,
      cursorX: 0,
      cursorY: 0,
      inactivityTimer: null,
    };
  },
  methods: {
    onMouseEnter(event) {
      this.showTooltip();
      this.updatePosition(event);
    },
    onMouseLeave() {
      this.hideTooltip();
    },
    onMouseMove(event) {
      this.updatePosition(event);
      this.resetInactivityTimer();
    },
    updatePosition(event) {
      this.cursorX = event.clientX;
      this.cursorY = event.clientY;
    },
    showTooltip() {
      this.isVisible = true;
      this.resetInactivityTimer();
    },
    hideTooltip() {
      clearTimeout(this.inactivityTimer);
      this.isVisible = false;
    },
    resetInactivityTimer() {
      clearTimeout(this.inactivityTimer);
      this.inactivityTimer = setTimeout(() => {
        this.isVisible = false;
      }, this.timeout);
    },
  },
  beforeDestroy() {
    clearTimeout(this.inactivityTimer);
  },
};
</script>

<style scoped>
.fade-enter-active {
  transition: opacity 0.2s ease-in;
}
.fade-leave-active {
  transition: opacity 0.3s ease-out;
}
.fade-enter,
.fade-leave-to {
  opacity: 0;
}
</style>